import { useState } from 'react'

import { ETitle, CloseButton, Modal } from '../../../../components/ui'
import { Button } from '../../../../components/ui/legacy'

import { tempate_1 } from '../../../../lib/email/template/email_template'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
} from '../../../../utils/showToast'
import { send_email_service } from '../../../../lib/email/email_service'

import { RichTextArea } from '../../../../components/ui/legacy'

import { Input } from '../../../../components/ui/legacy'
import { UTitle } from '../../../../components/ui'
import { validate_microsoft_email } from '../../../../utils/email_validation'

function ErrorResponseOverview({
  emai,
  setEmail,
  title,
  isEmailValidated,
  setIsEmailValidated,
}) {
  const handleEmailOnChange = (e) => {
    const trimmedInput = e.target.value.trim()
    const isValidEmail = validate_microsoft_email(trimmedInput)
    setIsEmailValidated(isValidEmail)
    setEmail(trimmedInput)
  }
  return (
    <div className="grid grid-cols-1 gap-3 md:gap-5">
      <UTitle text={'THÔNG TIN CHUNG'} />
      {/* <div className="container mx-auto"> */}
      <Input
        label="Địa chỉ nhận thư"
        type="email"
        placeholder="Nhập địa chỉ email"
        onChangeHandler={handleEmailOnChange}
        value={emai}
        isError={!isEmailValidated}
      />
      <Input
        label="Tiêu đề thư"
        type="text"
        placeholder="Nhập tiêu đề thư"
        value={title}
      />
      {/* </div>r */}
    </div>
  )
}

function ErrorResponseContent({ text, setText, isContent, setIsContent }) {
  const handleContentOnchange = (data) => {
    setIsContent(data.length !== 0)
    setText(data)
  }
  return (
    <div>
      <h2 className="text-lg font-bold md:text-2xl">NỘI DUNG PHẢN HỒI</h2>

      <RichTextArea
        content={text}
        setContent={handleContentOnchange}
        className={`${
          isContent
            ? 'border-2 border-gray-secondary'
            : 'border-2 border-red-accent'
        }`}
      />
    </div>
  )
}

export default function ErrorResponseModal({
  closeErrorResponseModal,
  userID,
  responseCode,
  uuid, // sau thay vào xử lý sau
}) {
  const emailTitle = `[NEU Reader] Phản hồi báo lỗi mã số #${responseCode}`
  const [email, setEmail] = useState(`${userID}@st.neu.edu.vn`)
  const [content, setContent] = useState(tempate_1)
  const [isLoading, setIsLoading] = useState(false)

  const [isEmailValidated, setIsEmailValidated] = useState(true)
  const [isContent, setIsContent] = useState(true)

  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  const sendResponse = async () => {
    // Email sai cú pháp, không có content thì không thể gửi
    if (!isEmailValidated || !isContent) {
      return
    }
    startLoading()
    const loadingToastId = showLoadingToast('Đang gửi phản hồi ...')
    try {
      const result = await send_email_service({
        to_email: email.trim(),
        content: content.trim(),
        log_id: responseCode.trim(),
      })
      if (result.success) {
        showSuccessToast(result.message, loadingToastId)
        closeErrorResponseModal() // Đóng modal khi thành công
      } else {
        showErrorToast({
          message: result.message,
          error: result.error,
          loadingToastId: loadingToastId,
        })
      }
    } catch (error) {
      showErrorToast({
        message: 'Đã xảy ra lỗi khi gửi email.',
        error: error.message,
        loadingToastId: loadingToastId,
      })
    } finally {
      stopLoading()
    }
  }

  return (
    <Modal
      onClose={closeErrorResponseModal}
      className="grid max-w-[700px] grid-cols-1 gap-2 rounded-lg bg-white p-6 shadow-lg sm:px-14 sm:py-8 md:gap-5"
    >
      <header className="flex items-start justify-between gap-1 md:gap-2">
        <ETitle text={'GỬI THƯ ĐIỆN TỬ PHẢN HỒI BÁO LỖI'} />
        <CloseButton onClickHandler={closeErrorResponseModal} />
      </header>
      <section className="grid grid-cols-1 gap-5 md:gap-9">
        <ErrorResponseOverview
          title={emailTitle}
          emai={email}
          setEmail={setEmail}
          isEmailValidated={isEmailValidated}
          setIsEmailValidated={setIsEmailValidated}
        />
        <ErrorResponseContent
          text={content}
          setText={setContent}
          isContent={isContent}
          setIsContent={setIsContent}
        />
      </section>
      <Button
        variant={'primary'}
        fullWidth={true}
        onClickHandler={sendResponse}
        disabled={isLoading}
      >
        Gửi phản hồi
      </Button>
    </Modal>
  )
}
